import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { MarkAnalysisCompleteToolArguments } from 'services/types/ticket';
import textToReactNodes from 'utils/textToReactNodes';

import MessageWrapper from './MessageWrapper';

interface Props {
  args: string;
}

const MarkAnalysisCompleteToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: MarkAnalysisCompleteToolArguments;

  try {
    parsedArgs = JSON.parse(args) as MarkAnalysisCompleteToolArguments;
  } catch (_error) {
    return (
      <MessageWrapper caption="Herramienta de Finalización" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Finalizar análisis" align="left">
      <Box>
        <Alert severity="success" sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            Análisis completado
          </Typography>
          <Typography variant="body2">
            El ticket será marcado como completado y se finalizará el ciclo de análisis de IA.
          </Typography>
        </Alert>

        <Box
          sx={{
            mb: 1,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            Resumen del análisis:
          </Typography>
          <Box
            sx={{
              bgcolor: 'grey.50',
              p: 2,
              borderRadius: 1,
              mt: 0.5,
            }}
          >
            {textToReactNodes(parsedArgs.summary)}
          </Box>
        </Box>

        {parsedArgs.nextSteps && (
          <Box
            sx={{
              mb: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Próximos pasos recomendados:
            </Typography>
            <Box
              sx={{
                bgcolor: 'grey.50',
                p: 2,
                borderRadius: 1,
                mt: 0.5,
                whiteSpace: 'pre-wrap',
              }}
            >
              {textToReactNodes(parsedArgs.nextSteps)}
            </Box>
          </Box>
        )}
      </Box>
    </MessageWrapper>
  );
};

export default MarkAnalysisCompleteToolComponent;
